import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { IntegrationCoaMapping } from "@common/schemas/domains/accounting/integrationCoaMapping.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const TransactionTypeCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, IntegrationCoaMapping, string>) => (
        <ViewTableCell>
            <span>{row.original.label}</span>
        </ViewTableCell>
    ),
);
TransactionTypeCell.displayName = "TransactionTypeCell";
